<template>
  <div v-if="loaded" class="w-full">
    <CWManagePages v-if="client === 'client1tenant'" />
    <ExpoManagePages v-else :manager_menu="manager_menu" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CWManagePages from '../../careerwise/tenant/manager/pages/ManagePages.vue'
import ExpoManagePages from '../../expo/tenant/manager/ManagePages.vue'

export default {
  components: {
    CWManagePages,
    ExpoManagePages,
  },

  data() {
    return {
      manager_menu: [],
      loaded: false,
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      menu: 'shared/getMenu',
      client: 'shared/getClient',
    }),
  },

  mounted() {
    this.$set(this, 'manager_menu', this.menu)
    this.$set(this, 'loaded', true)
  },
}
</script>
